import React from 'react';
import pt from 'prop-types';
import Popover from 'components/popover';

import './tooltip.scss';

export default class Tooltip extends React.PureComponent {
  static propTypes = {
    side: pt.oneOf(['top', 'left', 'bottom', 'right']),
    align: pt.oneOf(['start', 'center', 'end']),
    length: pt.string,
    delayed: pt.bool,
    message: pt.oneOfType([pt.string, pt.object]),
    className: pt.string,
    maxTextLineWidth: pt.number,
    maxTextLineSeparator: pt.string,
    sideOffset: pt.number,
    arrow: pt.bool,
    children: pt.node.isRequired,
    openOnHover: pt.bool,
  };

  render() {
    const {
      side = 'top',
      align = 'center',
      message = '',
      openOnHover = true,
      delayed = false,
      sideOffset,
      maxTextLineWidth,
      maxTextLineSeparator,
      arrow,
      children,
    } = this.props;

    if (!message) {
      return children;
    }

    return (
      <span className="tooltip-help" role="tooltip">
        <Popover
          side={side}
          sideOffset={sideOffset}
          align={align}
          message={message}
          enterDuration={delayed ? 250 : undefined}
          maxTextLineWidth={maxTextLineWidth}
          maxTextLineSeparator={maxTextLineSeparator}
          triggerChildren={children}
          triggerOnClick={() => {}}
          openOnHover={openOnHover}
          arrow={arrow}
        />
      </span>
    );
  }
}
